import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Section } from './Section';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <Section tone="white" title="Your professional clinical toolkit" subtitle="Five specialized tools included with your purchase — each designed for a specific task in your obesity care workflow." cta="Yes, I want all five tools" ctaNote="All five specialized tools are included with your $27 purchase." data-id="element-62" data-mp="av37exjcfd39">
      <div className="space-y-10 md:space-y-12" data-id="element-63" data-mp="5x1lm4uj8zo3">
        {bonuses.map(bonus => <article key={bonus.number} className="-mx-4 overflow-hidden bg-canvas sm:mx-0 sm:rounded-3xl md:grid md:grid-cols-2 md:items-center" data-id="element-64" data-mp="3o2eow0fp6p5a">
            <div className="bg-white" data-id="element-65" data-mp="1mai37xztfyws">
              <img src={bonus.image} alt={`Bonus #${bonus.number}: ${bonus.title}`} className="block w-full" loading="lazy" data-id="element-66" data-mp="1mbjpkyma87tt" />
            </div>
            <div className="px-5 py-7 sm:px-8 md:py-10" data-id="element-67" data-mp="3iclj3fk53ws0">
              <span className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" style={{
            backgroundColor: bonus.accent
          }} data-id="element-68" data-mp="3dg4xot4brwim">
                <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-69" data-mp="3n5y7ppotk3kr" />
                Bonus #{bonus.number}
              </span>
              <h3 className="mt-4 font-serif text-[26px] font-bold leading-tight text-ink sm:text-3xl" data-id="element-70" data-mp="2ugh9gbeipsgm">{bonus.title}</h3>
              <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-71" data-mp="38gs29jze1h4f">{bonus.description}</p>
              <ul className="mt-5 space-y-2.5" data-id="element-72" data-mp="33gnv4kkddyqv">
                {bonus.includes.map(item => <li key={item} className="flex gap-3" data-id="element-73" data-mp="npi46dhtlyt6">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0" style={{
                color: bonus.accent
              }} strokeWidth={3} aria-hidden="true" data-id="element-74" data-mp="ns4bcc0sucav" />
                    <span className="text-[16px] text-ink" data-id="element-75" data-mp="3cj6h6da27qou">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-line pt-5" data-id="element-76" data-mp="3hgyc7g603sx9">
                <span className="text-[16px] text-muted" data-id="element-77" data-mp="3lkw7tgw4allk">
                  Reference value: <s className="font-semibold" data-id="element-78" data-mp="3qixra2xggmxk">${bonus.value}</s>
                </span>
                <span className="rounded-lg bg-cta/10 px-3 py-1.5 text-sm font-extrabold uppercase tracking-wide text-cta-dark" data-id="element-79" data-mp="2tsykoe0v7yhm">
                  Included free
                </span>
              </div>
            </div>
          </article>)}
      </div>
    </Section>;
}